import { z } from "zod";
import { defineStepConfig } from "@erp/workflows";
import { entityOfType } from "../../../utils/system-entities";
import { SystemEntity } from "@erp/shared-types";

/**
 * Extract AP Invoice from Email Step
 *
 * Uses AI to extract structured invoice data from the email and its attachments.
 * This step calls the APInvoiceExtractionService which:
 * - Analyzes email content and OCR'd attachment text
 * - Extracts invoice details (number, date, amount, line items, etc.)
 * - Identifies supplier information
 * - Creates an extraction result record
 *
 * Note: This is a backend-only step that requires database access.
 * The handler is registered in backend/src/workflows/steps/handlers/
 */
export const extractAPInvoiceFromEmailStep = defineStepConfig({
  type: "extract_ap_invoice_from_email",
  name: "Extract AP Invoice Data",
  description:
    "Extract structured invoice data from email and attachments using AI",
  category: "Data Access",
  libraryModule: "AccountsPayable",
  deprecated: {
    reason: "Domain-specific AP invoice step",
  },

  inputSchema: z.object({
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL),
  }),

  outputSchema: z.object({
    extractionResultId: z.uuid(),
  }),

  configSchema: z.object({
    // Future: add config for extraction models, confidence thresholds
  }),

  emits: [] as const,
});
